export const appUserSelectNone = (p) => p.theme.isApp && `user-select: none;`;
